import IngredientsCarousel, {
  IngredientsCarouselProps,
  IngredientsCarouselSlide,
  IngredientsCarouselMedia,
  getMediaTypeFromFilename,
} from "./IngredientsCarousel";

export {
  IngredientsCarousel,
  IngredientsCarouselProps,
  IngredientsCarouselSlide,
  IngredientsCarouselMedia,
  getMediaTypeFromFilename,
};

export default IngredientsCarousel;
